module.exports = __webpack_public_path__ + "assets/manage3.9308a955.svg";